import { defineMessages } from 'react-intl';

export const ratingInputMessages = defineMessages({
  inputHint: {
    defaultMessage: '1 (Mangelhaft) - 5 (Super)*',
    id: 'customerReviews.addReview.ratingInput.inputHint',
  },
  ratingDefault: {
    defaultMessage: 'Wie findest du das Produkt?',
    id: 'customerReviews.addReview.ratingInput.default',
  },
  rating1: {
    defaultMessage: 'Mangelhaft',
    id: 'customerReviews.addReview.ratingInput.rating1',
  },
  rating2: {
    defaultMessage: 'Nicht so gut',
    id: 'customerReviews.addReview.ratingInput.rating2',
  },
  rating3: {
    defaultMessage: 'Okay',
    id: 'customerReviews.addReview.ratingInput.rating3',
  },
  rating4: {
    defaultMessage: 'Gut',
    id: 'customerReviews.addReview.ratingInput.rating4',
  },
  rating5: {
    defaultMessage: 'Super',
    id: 'customerReviews.addReview.ratingInput.rating5',
  },
  error: {
    defaultMessage: 'Du musst einen Wert für die Gesamtbewertung eingeben.',
    id: 'customerReviews.addReview.ratingInput.error',
  },
});
